import React, { Component } from 'react'
import LicensePlate from '../LicensePlate'
import './carrentalplate.scss'

class CarRentalPlate extends Component {

  render () {
    return (
      <div className='carrental-plate'>
        <LicensePlate regNr={this.props.regNr} countryCode={this.props.countryCode} />
        <div className='carnumber'>
          <div className='carnumber__line' />
          <div className='carnumber__nr'>{this.props.nr}</div>
        </div>
      </div>
    )
  }
}

CarRentalPlate.defaultProps = {
  regNr: 'XX 12 123',
  countryCode: 'dk',
  nr: '10'
}

export default CarRentalPlate




// WEBPACK FOOTER //
// ./src/app/shared/components/CarRentalPlate/index.js